import { useSyncExternalStore } from 'react';

// For useSyncExternalStore over browser values that never notify a change.
export const subscribeToNothing = () => () => {};

// False on the server and during hydration, true afterwards. Replaces the
// `useEffect(() => setMounted(true), [])` pattern for markup that must not
// differ from the server-rendered HTML while hydrating.
const useHydrated = (): boolean =>
  useSyncExternalStore(
    subscribeToNothing,
    () => true,
    () => false,
  );

export default useHydrated;
